import React, { useState } from 'react';
import { useStore } from '../../utils/score';


const Otazka = ({ data, cardIndex }) => {

    const [score, setScore] = useState(0);
    const {pridajZlatoScore, pridajKremikScore} = useStore()

    const handleAnswerOptionClick = (isCorrect, team, points) => {
		if (isCorrect) {
            team === "zlato" ? pridajZlatoScore(points) : pridajKremikScore(points)
		}
	};
    
 

    return (
        <div>
        {data[cardIndex].map((item, index) => (
            
            <div key={index}>
                <div className="quesiton-container"> 
                    <h1>{item.title}</h1>
                    <p>{item.otazka}</p>
                    <p>{score}</p>
                </div> 
                <div className='btn-container'>

                        {item.answerOptions && item.answerOptions.map((answerOption) => (
							<button className="btn btn-yes" onClick={() => handleAnswerOptionClick(answerOption.isCorrect,item.team)}>{answerOption.answerText}</button>
						))}
						
				</div>

                

            </div>
        ))}
         </div>
   
    );
};


export default Otazka;


